import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ShippingOne from "../components/ShippingOne";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import { useAuth } from "../contexts/AuthContext";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import '../styles/phone-input.scss';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

// Form doğrulama şeması
const schema = yup.object().shape({
  firstName: yup
    .string()
    .required("Ad alanı zorunludur")
    .min(2, "Ad en az 2 karakter olmalıdır"),
  lastName: yup
    .string()
    .required("Soyad alanı zorunludur")
    .min(2, "Soyad en az 2 karakter olmalıdır"),
  email: yup
    .string()
    .required("E-posta alanı zorunludur")
    .email("Geçerli bir e-posta adresi giriniz"),
  password: yup
    .string()
    .required("Şifre alanı zorunludur")
    .min(8, "Şifre en az 8 karakter olmalıdır"),
  confirmPassword: yup
    .string()
    .required("Şifre tekrar alanı zorunludur")
    .oneOf([yup.ref("password"), null], "Şifreler eşleşmiyor"),
  termsAccepted: yup
    .boolean()
    .oneOf([true], "Üyelik sözleşmesini kabul etmelisiniz")
});

const RegisterPage = () => {
  const navigate = useNavigate();
  const { register: authRegister } = useAuth();
  const [error, setError] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isNewsletterSubscribed, setIsNewsletterSubscribed] = useState(false);
  
  // React Hook Form
  const { register, handleSubmit, formState: { errors, isValid } } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange" // Form değişikliklerinde anında doğrulama yap
  });

  const onSubmit = async (data) => {
    setError("");
    
    try {
      const registerData = {
        ...data,
        phoneNumber,
        isNewsletterSubscribed
      };
      
      const result = await authRegister(registerData);
      if (result.success) {
        navigate("/login", { state: { message: "Kayıt başarılı! Lütfen giriş yapın." } });
      } else {
        setError(result.error || "Kayıt sırasında bir hata oluştu");
      }
    } catch (error) {
      setError("Kayıt sırasında bir hata oluştu: " + (error.message || error));
    }
  };

  return (
    <>
      <ColorInit color={false} />
      <ScrollToTop smooth color="#299E60" />
      <Preloader />
      <HeaderOne />
      <Breadcrumb title={"Kayıt Ol"} />

      <div className="login-area pt-100 pb-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="login-form-wrapper">
                <h3>Yeni Hesap Oluştur</h3>
                {error && <div className="alert alert-danger">{error}</div>}
                <form onSubmit={handleSubmit(onSubmit)} className="login-form">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="single-input-item">
                        <label>Ad *</label>
                        <input
                          type="text"
                          placeholder="Adınızı giriniz"
                          className={`form-control ${errors.firstName ? "is-invalid" : ""}`}
                          {...register("firstName")}
                        />
                        {errors.firstName && (
                          <div className="invalid-feedback">{errors.firstName.message}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="single-input-item">
                        <label>Soyad *</label>
                        <input
                          type="text"
                          placeholder="Soyadınızı giriniz"
                          className={`form-control ${errors.lastName ? "is-invalid" : ""}`}
                          {...register("lastName")}
                        />
                        {errors.lastName && (
                          <div className="invalid-feedback">{errors.lastName.message}</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="single-input-item">
                        <label>E-posta Adresi *</label>
                        <input
                          type="email"
                          placeholder="E-posta adresinizi giriniz"
                          className={`form-control ${errors.email ? "is-invalid" : ""}`}
                          {...register("email")}
                        />
                        {errors.email && (
                          <div className="invalid-feedback">{errors.email.message}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="single-input-item">
                        <label>Telefon Numarası</label>
                        <PhoneInput
                          country={'tr'}
                          value={phoneNumber}
                          onChange={(value) => setPhoneNumber(value)}
                          inputClass="form-control"
                          containerStyle={{width: '100%'}}
                          inputStyle={{width: '100%', height: '45px'}}
                          buttonStyle={{borderTopLeftRadius: '4px', borderBottomLeftRadius: '4px'}}
                          placeholder="Telefon numaranızı giriniz"
                          enableSearch={false}
                          countryCodeEditable={false}
                          preferredCountries={['tr', 'us', 'gb', 'de', 'fr']}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="single-input-item">
                        <label>Şifre *</label>
                        <input
                          type="password"
                          placeholder="Şifrenizi giriniz"
                          className={`form-control ${errors.password ? "is-invalid" : ""}`}
                          {...register("password")}
                        />
                        {errors.password && (
                          <div className="invalid-feedback">{errors.password.message}</div>
                        )}
                        <small className="form-text text-muted">
                          Şifreniz en az 8 karakter uzunluğunda olmalıdır.
                        </small>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="single-input-item">
                        <label>Şifre Tekrar *</label>
                        <input
                          type="password"
                          placeholder="Şifrenizi tekrar giriniz"
                          className={`form-control ${errors.confirmPassword ? "is-invalid" : ""}`}
                          {...register("confirmPassword")}
                        />
                        {errors.confirmPassword && (
                          <div className="invalid-feedback">{errors.confirmPassword.message}</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="single-input-item checkbox-item">
                    <input 
                      type="checkbox" 
                      id="newsletter" 
                      checked={isNewsletterSubscribed}
                      onChange={(e) => setIsNewsletterSubscribed(e.target.checked)}
                    />
                    <label htmlFor="newsletter">
                      Kampanya ve fırsatlardan haberdar olmak istiyorum
                    </label>
                  </div>

                  <div className="single-input-item checkbox-item">
                    <input 
                      type="checkbox" 
                      id="terms" 
                      className={errors.termsAccepted ? "is-invalid" : ""}
                      {...register("termsAccepted")}
                    />
                    <label 
                      htmlFor="terms" 
                      className={errors.termsAccepted ? "text-danger" : ""}
                    >
                      <Link to="#" className="text-theme">Üyelik sözleşmesini</Link> okudum ve kabul ediyorum
                    </label>
                    {errors.termsAccepted && (
                      <div className="invalid-feedback d-block">{errors.termsAccepted.message}</div>
                    )}
                  </div>

                  <div className="single-input-item">
                    <button 
                      type="submit" 
                      className="btn-hover login-btn"
                      disabled={!isValid}
                      style={{
                        opacity: isValid ? 1 : 0.7,
                        cursor: isValid ? 'pointer' : 'not-allowed'
                      }}
                    >
                      Kayıt Ol
                    </button>
                  </div>

                  <div className="divider">
                    <span>veya</span>
                  </div>

                  <div className="single-input-item">
                    <Link to="/login" className="btn-hover register-btn">
                      Giriş Yap
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ShippingOne />
      <FooterOne />
      <BottomFooter />
    </>
  );
};

export default RegisterPage; 